const types = {
  SET_ROLES: "SET_ROLES",
  SET_JWT: "SET_JWT",
  SET_USER_ID: "SET_USER_ID",
  USER_LOGOUT: "USER_LOGOUT",
};

export const setRoles = (roles) => ({
  type: types.SET_ROLES,
  payload: { roles },
});

export const setJwt = (jwt) => ({
  type: types.SET_JWT,
  payload: { jwt },
});

export const setUserId = (id) => ({
  type: types.SET_USER_ID,
  payload: { id },
});

export const userLogout = () => ({
  type: types.USER_LOGOUT,
});
